// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"205aa91e","813":"d131dc3e","930":"53b44c97","938":"d844a552"}[chunkId] + ".chunk.js";
};